<template>
    <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span>{{ isEntryMode ? "Add Asset Assignment" : "Update Asset Assignment" }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="assetRegisterAssignmentSetup">
                    <v-row>

                        <v-col cols="12">
                            <v-date-input
                            density="compact"
                            prepend-icon=""
                            prepend-inner-icon="mdi-calendar"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="end_date.value.value"
                            :error-messages="end_date.errorMessage.value"
                            autocomplete="off"
                            clearable
                            >
                                <template #label>
                                End Date
                                <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                            class="bg-red"
                            variant="flat"
                            type="reset"
                            @click="closeDialog"
                            >Close</v-btn
                            >
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { getCurrentInstance } from "vue";
import formattedDate from "@/plugins/dateFormatter";

export default {
    name: "AssetRegisterAssignmentSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                asset_register_id: null,
                end_date: null,
            }),
        },
    },
    data() {
        return {
            mainId :null,
            localDialog: this.dialog,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
        };
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                console.log(newData)
                this.isEntryMode = !newData.id;
                this.resetForm({ errors: {}, touched: {} });
                this.asset_assignment_id.setValue(newData.id || "", false);
                this.asset_register_id.setValue(newData.asset_register_id || null, false);
                this.end_date.setValue(newData.end_date || null, false);
            },
        },
    },
    created() {},
    computed: {},
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                end_date: yup.string().trim().required("End Date is required").max(255, "End Date cannot exceed 255 characters").label("End Date"),
            }),
        });

        const asset_assignment_id = useField("asset_assignment_id");
        const asset_register_id =useField("asset_register_id");
        const end_date = useField("end_date");

        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();
        
        const submit = handleSubmit((values) => {
            const asset_id = proxy.mainId;
            values.asset_register_id = asset_id;
            values.end_date = formattedDate(end_date.value.value);
            store
                .dispatch("saveUpdateAssetUnassignment", values)
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    toast.success(response.data.message);
                    store.dispatch("getAssetAssignmentsList", { asset_register_id: asset_id });
                })
                .catch((error) => {
                    toast.error(error?.response?.data?.message || "Something went wrong");
                });
        });

        return {
            submit,
            asset_assignment_id,
            asset_register_id,
            end_date,
            errorMessages,
            resetForm,
            loading,
        };
    },
    mounted() {
        const id = this.$route.params.id;
        this.mainId = id;
    },
};
</script>
